// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2718%27 height=%2714%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M16.552.134 5.717 10.97 1.448 6.701 0 8.149l5.717 5.717L18 1.583 16.552.134Z%27 fill=%27%23EA455F%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2718%27 height=%2714%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M16.552.134 5.717 10.97 1.448 6.701 0 8.149l5.717 5.717L18 1.583 16.552.134Z%27 fill=%27%23FFFFFF%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2718%27 height=%2718%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M18 1.414 16.586 0 9 7.586 1.414 0 0 1.414 7.586 9 0 16.586 1.414 18 9 10.414 16.586 18 18 16.586 10.414 9 18 1.414Z%27 fill=%27%23B1B8C9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg width=%2742%27 height=%2742%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M3.813 11.077 21 1.155l17.187 9.922v19.846L21 40.845 3.813 30.923V11.077Z%27 stroke=%27%23fff%27 stroke-width=%272%27/%3E%3Ccircle cx=%2721%27 cy=%2721%27 r=%278%27 stroke=%27%23fff%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --baseColor: #656c7c;
  --baseSize: 16px;
  --baseLineHeight: 1.5;
  --fontFamily: Inter, sans-serif;
  --pink: #ea4c89;
  --pinkLight: #ffecf0;
  --blue: #1769ff;
  --redTick: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --whiteTick: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --close: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  --entpIcon: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

* {
  box-sizing: border-box;
}

html {
  color: var(--baseColor);
  font-family: var(--fontFamily);
  font-size: var(--baseSize);
  line-height: var(--baseLineHeight);
}

body {
  margin: 0;
}

.plans {
  width: 96%;
  max-width: 1128px;
  margin: 0 auto;
}
.plans__container {
  padding: 1rem 0 2rem;
}

.plansHero {
  text-align: center;
  padding: 5rem 0 4.5rem;
  line-height: 1.21;
}
.plansHero__title {
  font-weight: 700;
  font-size: 2rem;
  margin: 0 0 1rem 0;
  color: #000;
}
.plansHero__subtitle {
  margin: 0;
}

.planItem {
  --border: 1px solid #e6e6e6;
  --bgColor: #fff;
  --boxShadow: none;
  background-color: var(--bgColor);
  border: var(--border);
  border-radius: 1rem;
  box-shadow: var(--boxShadow);
  padding: 2rem 1.5rem;
  display: inline-flex;
  flex-direction: column;
}
.planItem__container {
  --direction: column;
  display: grid;
  grid-auto-flow: var(--direction);
  grid-auto-columns: 1fr;
  gap: 1.5rem;
}
.planItem .price {
  --priceMargin: 2rem 0;
}
.planItem--pro {
  --bgColor:#9df9dd;
  --border: 0;
  --boxShadow: 0px 14px 30px rgba(204, 204, 204, 0.32);
}
.planItem--pro .label {
  --labelBg: #fdb72e;
  --labelColor: #fff;
}
.planItem--entp {
  --bgColor: var(--blue);
}
.planItem--entp .card {
  --titleColor: #fff;
  --descColor: rgb(255 255 255 / 80%);
}
.planItem--entp .card__icon {
  background-image: var(--entpIcon);
  background-size: cover;
}
.planItem--entp .price,
.planItem--entp .featureList {
  --color: #fff;
}
.planItem--entp .featureList {
  --icon: var(--whiteTick);
}
.planItem .button {
  margin-top: auto;
}

.button {
  --bgColor: var(--pinkLight);
  --color: var(--pink);
  --shadowColor: rgb(234 76 137 / 30%);
  --outline: var(--pink);
  border-radius: 0.5rem;
  display: block;
  width: 100%;
  padding: 1rem 1.5rem;
  border: 0;
  line-height: inherit;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  background-color: var(--bgColor);
  color: var(--color);
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  -webkit-user-select: none;
          user-select: none;
}
.button--pink {
  --bgColor: var(--pink);
  --color: #fff;
  --shadowColor: rgb(234 76 137 / 50%);
}
.button--white {
  --bgColor: #fff;
  --shadowColor: rgb(255 255 255 / 30%);
  --outline: #fff;
}
.button:hover {
  transform: translateY(-2px);
  box-shadow: 0px 6px 10px var(--shadowColor);
}
.button:focus-visible {
  outline-offset: 2px;
  outline: 2px solid var(--outline);
}

.card {
  --titleColor: #000;
  --descColor: var(--baseColor);
}
.card__header {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.card__icon {
  width: 2.625rem;
  height: 2.625rem;
}
.card h2 {
  color: var(--titleColor);
  font-size: 1.5rem;
  line-height: 1.2;
  font-weight: 400;
  margin: 0;
  flex-grow: 1;
}
.card__desc {
  margin: 1.5rem 0 0;
  color: var(--descColor);
}

.label {
  --labelColor: var(--baseColor);
  --labelBg: #e5e5e5;
  font-weight: 600;
  line-height: 1.25;
  font-size: 1rem;
  text-align: center;
  padding: 0.625rem 1.125rem;
  border-radius: 2rem;
  -webkit-user-select: none;
          user-select: none;
  background-color: var(--labelBg);
  color: var(--labelColor);
}

.price {
  --color: #000;
  --priceMargin: 0;
  display: flex;
  color: var(--color);
  align-items: center;
  gap: 0.5625rem;
  font-weight: 600;
  font-size: 2rem;
  margin: var(--priceMargin);
}
.price span {
  font-size: 1rem;
  font-weight: 400;
  color: var(--baseColor);
}

.featureList {
  --color: #000;
  --icon: var(--redTick);
  --height: 0.875rem;
  margin: 0 0 2.75rem;
  padding: 0;
  font-weight: 500;
}
.featureList li {
  color: var(--color);
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.featureList li:before {
  content: "";
  background-image: var(--icon);
  background-size: cover;
  display: block;
  width: 1.125rem;
  height: var(--height);
}
.featureList li:last-child {
  margin-bottom: 0;
}
.featureList li.disabled {
  --color: #b1b8c9;
  --height: 1.125rem;
  --icon: var(--close);
}

.symbol {
  --big: 2.625rem;
  --small: 1.5rem;
  --radius: 0.25rem;
  border: 2px solid var(--blue);
  width: var(--big);
  height: var(--big);
  border-radius: var(--radius);
  position: relative;
}
.symbol--rounded {
  --radius: 2rem;
}
.symbol:after {
  content: "";
  box-sizing: border-box;
  display: block;
  position: absolute;
  border: 2px solid var(--pink);
  width: var(--small);
  height: var(--small);
  border-radius: var(--radius);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 640px) {
  .plans {
    max-width: 480px;
    width: 90%;
  }
  .planItem__container {
    --direction: row;
  }
}
@media screen and (min-width: 641px) and (max-width: 768px) {
  :root {
    --baseSize: 12px;
  }
}
@media screen and (min-width: 769px) and (max-width: 1080px) {
  :root {
    --baseSize: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/stripe/plans/PricingOptions.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,+BAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EAEA,kDAAA;EAEA,oDAAA;EAEA,gDAAA;EAEA,mDAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAOA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,kCAAA;AAJF;;AAOA;EACE,SAAA;AAJF;;AAOA;EAKE,UAAA;EACA,iBAAA;EACA,cAAA;AARF;AAEE;EACE,oBAAA;AAAJ;;AASA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;AANF;AAQE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AANJ;AASE;EACE,SAAA;AAPJ;;AAaA;EACE,2BAAA;EACA,eAAA;EACA,iBAAA;EAWA,gCAAA;EACA,qBAAA;EACA,mBAAA;EACA,4BAAA;EACA,oBAAA;EACA,oBAAA;EACA,sBAAA;AApBF;AAKE;EACE,mBAAA;EAEA,aAAA;EACA,gCAAA;EACA,sBAAA;EACA,WAAA;AAJJ;AAeE;EACE,qBAAA;AAbJ;AAmBE;EACE,iBAAA;EACA,WAAA;EACA,oDAAA;AAjBJ;AAmBI;EACE,kBAAA;EACA,kBAAA;AAjBN;AAqBE;EACE,sBAAA;AAnBJ;AAqBI;EACE,kBAAA;EACA,mCAAA;AAnBN;AAqBM;EACE,iCAAA;EACA,sBAAA;AAnBR;AAuBI;;EAEE,aAAA;AArBN;AAwBI;EACE,wBAAA;AAtBN;AA0BE;EACE,gBAAA;AAxBJ;;AA8BA;EACE,2BAAA;EACA,oBAAA;EACA,oCAAA;EACA,sBAAA;EAEA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;EACA,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;UAAA,iBAAA;AA5BF;AA8BE;EACE,sBAAA;EACA,aAAA;EACA,oCAAA;AA5BJ;AA+BE;EACE,eAAA;EACA,qCAAA;EACA,eAAA;AA7BJ;AAgCE;EACE,2BAAA;EACA,2CAAA;AA9BJ;AAiCE;EACE,mBAAA;EACA,iCAAA;AA/BJ;;AAmCA;EACE,kBAAA;EACA,6BAAA;AAhCF;AAkCE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAhCJ;AAmCE;EACE,eAAA;EACA,gBAAA;AAjCJ;AAoCE;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;AAlCJ;AAqCE;EACE,kBAAA;EACA,uBAAA;AAnCJ;;AAuCA;EACE,8BAAA;EACA,kBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gCAAA;EACA,wBAAA;AArCF;;AAwCA;EACE,aAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAtCF;AAwCE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAtCJ;;AA0CA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,UAAA;EACA,gBAAA;AAxCF;AA0CE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAxCJ;AA0CI;EACE,WAAA;EACA,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAxCN;AA2CI;EACE,gBAAA;AAzCN;AA4CI;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;AA1CN;;AA+CA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EAEA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kBAAA;AA7CF;AA+CE;EACE,cAAA;AA7CJ;AAgDE;EACE,WAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AA9CJ;;AAoDA;EACE;IACE,gBAAA;IACA,UAAA;EAjDF;EAoDA;IACE,gBAAA;EAlDF;AACF;AAqDA;EACE;IACE,gBAAA;EAnDF;AACF;AAsDA;EACE;IACE,gBAAA;EApDF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n:root {\n  --baseColor: #656c7c;\n  --baseSize: 16px;\n  --baseLineHeight: 1.5;\n  --fontFamily: Inter, sans-serif;\n  --pink: #ea4c89;\n  --pinkLight: #ffecf0;\n  --blue: #1769ff;\n\n  --redTick: url(\"data:image/svg+xml,%3Csvg width='18' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.552.134 5.717 10.97 1.448 6.701 0 8.149l5.717 5.717L18 1.583 16.552.134Z' fill='%23EA455F'/%3E%3C/svg%3E%0A\");\n\n  --whiteTick: url(\"data:image/svg+xml,%3Csvg width='18' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.552.134 5.717 10.97 1.448 6.701 0 8.149l5.717 5.717L18 1.583 16.552.134Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A\");\n\n  --close: url(\"data:image/svg+xml,%3Csvg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18 1.414 16.586 0 9 7.586 1.414 0 0 1.414 7.586 9 0 16.586 1.414 18 9 10.414 16.586 18 18 16.586 10.414 9 18 1.414Z' fill='%23B1B8C9'/%3E%3C/svg%3E\");\n\n  --entpIcon: url(\"data:image/svg+xml,%3Csvg width='42' height='42' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.813 11.077 21 1.155l17.187 9.922v19.846L21 40.845 3.813 30.923V11.077Z' stroke='%23fff' stroke-width='2'/%3E%3Ccircle cx='21' cy='21' r='8' stroke='%23fff' stroke-width='2'/%3E%3C/svg%3E\");\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  color: var(--baseColor);\n  font-family: var(--fontFamily);\n  font-size: var(--baseSize);\n  line-height: var(--baseLineHeight);\n}\n\nbody {\n  margin: 0;\n}\n\n.plans {\n  &__container {\n    padding: 1rem 0 2rem;\n  }\n\n  width: 96%;\n  max-width: 1128px;\n  margin: 0 auto;\n}\n\n// hero starts\n.plansHero {\n  text-align: center;\n  padding: 5rem 0 4.5rem;\n  line-height: 1.21;\n\n  &__title {\n    font-weight: 700;\n    font-size: 2rem;\n    margin: 0 0 1rem 0;\n    color: #000;\n  }\n\n  &__subtitle {\n    margin: 0;\n  }\n}\n// hero ends\n\n// plan item starts\n.planItem {\n  --border: 1px solid #e6e6e6;\n  --bgColor: #fff;\n  --boxShadow: none;\n\n  &__container {\n    --direction: column;\n\n    display: grid;\n    grid-auto-flow: var(--direction);\n    grid-auto-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  background-color: var(--bgColor);\n  border: var(--border);\n  border-radius: 1rem;\n  box-shadow: var(--boxShadow);\n  padding: 2rem 1.5rem;\n  display: inline-flex;\n  flex-direction: column;\n\n  .price {\n    --priceMargin: 2rem 0;\n  }\n\n  &--free {\n  }\n\n  &--pro {\n    --bgColor:#9df9dd;\n    --border: 0;\n    --boxShadow: 0px 14px 30px rgba(204, 204, 204, 0.32);\n\n    .label {\n      --labelBg: #fdb72e;\n      --labelColor: #fff;\n    }\n  }\n\n  &--entp {\n    --bgColor: var(--blue);\n\n    .card {\n      --titleColor: #fff;\n      --descColor: rgb(255 255 255 / 80%);\n\n      &__icon {\n        background-image: var(--entpIcon);\n        background-size: cover;\n      }\n    }\n\n    .price,\n    .featureList {\n      --color: #fff;\n    }\n\n    .featureList {\n      --icon: var(--whiteTick);\n    }\n  }\n\n  .button {\n    margin-top: auto;\n  }\n}\n// plan item ends\n\n// components start\n.button {\n  --bgColor: var(--pinkLight);\n  --color: var(--pink);\n  --shadowColor: rgb(234 76 137 / 30%);\n  --outline: var(--pink);\n\n  border-radius: 0.5rem;\n  display: block;\n  width: 100%;\n  padding: 1rem 1.5rem;\n  border: 0;\n  line-height: inherit;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 600;\n  background-color: var(--bgColor);\n  color: var(--color);\n  cursor: pointer;\n  transition: all 0.1s ease-in-out;\n  user-select: none;\n  \n  &--pink {\n    --bgColor: var(--pink);\n    --color: #fff;\n    --shadowColor: rgb(234 76 137 / 50%);\n  }\n\n  &--white {\n    --bgColor: #fff;\n    --shadowColor: rgb(255 255 255 / 30%);\n    --outline: #fff;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0px 6px 10px var(--shadowColor);\n  }\n\n  &:focus-visible {\n    outline-offset: 2px;\n    outline: 2px solid var(--outline);\n  }\n}\n\n.card {\n  --titleColor: #000;\n  --descColor: var(--baseColor);\n\n  &__header {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n  }\n\n  &__icon {\n    width: 2.625rem;\n    height: 2.625rem;\n  }\n\n  h2 {\n    color: var(--titleColor);\n    font-size: 1.5rem;\n    line-height: 1.2;\n    font-weight: 400;\n    margin: 0;\n    flex-grow: 1;\n  }\n\n  &__desc {\n    margin: 1.5rem 0 0;\n    color: var(--descColor);\n  }\n}\n\n.label {\n  --labelColor: var(--baseColor);\n  --labelBg: #e5e5e5;\n\n  font-weight: 600;\n  line-height: 1.25;\n  font-size: 1rem;\n  text-align: center;\n  padding: 0.625rem 1.125rem;\n  border-radius: 2rem;\n  user-select: none;\n  background-color: var(--labelBg);\n  color: var(--labelColor);\n}\n\n.price {\n  --color: #000;\n  --priceMargin: 0;\n\n  display: flex;\n  color: var(--color);\n  align-items: center;\n  gap: 0.5625rem;\n  font-weight: 600;\n  font-size: 2rem;\n  margin: var(--priceMargin);\n\n  span {\n    font-size: 1rem;\n    font-weight: 400;\n    color: var(--baseColor);\n  }\n}\n\n.featureList {\n  --color: #000;\n  --icon: var(--redTick);\n  --height: 0.875rem;\n\n  margin: 0 0 2.75rem;\n  padding: 0;\n  font-weight: 500;\n\n  li {\n    color: var(--color);\n    margin-bottom: 2rem;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n\n    &:before {\n      content: \"\";\n      background-image: var(--icon);\n      background-size: cover;\n      display: block;\n      width: 1.125rem;\n      height: var(--height);\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    &.disabled {\n      --color: #b1b8c9;\n      --height: 1.125rem;\n      --icon: var(--close);\n    }\n  }\n}\n\n.symbol {\n  --big: 2.625rem;\n  --small: 1.5rem;\n  --radius: 0.25rem;\n\n  border: 2px solid var(--blue);\n  width: var(--big);\n  height: var(--big);\n  border-radius: var(--radius);\n  position: relative;\n\n  &--rounded {\n    --radius: 2rem;\n  }\n\n  &:after {\n    content: \"\";\n    box-sizing: border-box;\n    display: block;\n    position: absolute;\n    border: 2px solid var(--pink);\n    width: var(--small);\n    height: var(--small);\n    border-radius: var(--radius);\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n}\n// components end\n\n// little adjustments for responsiveness\n@media screen and (max-width: 640px) {\n  .plans {\n    max-width: 480px;\n    width: 90%;\n  }\n\n  .planItem__container {\n    --direction: row;\n  }\n}\n\n@media screen and (min-width: 641px) and (max-width: 768px) {\n  :root {\n    --baseSize: 12px;\n  }\n}\n\n@media screen and (min-width: 769px) and (max-width: 1080px) {\n  :root {\n    --baseSize: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
